import AlertModal from "../AlertModal/AlertModal";
import removeIcon from "../../../assets/shared/remove_white.svg";
import { FormattedMessage } from "react-intl";
import { PropsWithChildren } from "react";
import AlertLevel from "../../../models/alert";

type DeleteWarningModalProps = {
  show: boolean;
  loading?: boolean;
  onConfirm?: () => void;
  onClose?: () => void;
};

const DeleteWarningModal = ({
  show,
  loading,
  onConfirm,
  onClose,
  children,
}: PropsWithChildren<DeleteWarningModalProps>) => {
  return (
    <AlertModal
      dialog
      show={show}
      loading={loading}
      onClose={onClose}
      okBtn={{
        text: (
          <FormattedMessage
            id="GLOBAL.DELETE_CONFIRM"
            defaultMessage="Yes, Delete"
          />
        ),
        onClick: onConfirm,
        icon: {
          src: removeIcon,
          height: 18,
          width: 18,
        },
      }}
      level={AlertLevel.Warning}
    >
      {children}
    </AlertModal>
  );
};

export default DeleteWarningModal;
